import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  requestChallengeImageUpload,
  confirmChallengeImageUpload,
  getChallengeImage,
  deleteChallengeImage,
} from 'api/challenges-v2'
import type {
  ChallengeImageType,
  RequestImageUploadResponse,
  ConfirmImageUploadResponse,
  GetImageResponse,
  DeleteImageResponse,
} from 'api/types'

export const requestChallengeMediaUpload = createAsyncThunk<
  RequestImageUploadResponse,
  { challengeId: string; challengeImageType: ChallengeImageType }
>('challengesMedia/requestUpload', async (file, { rejectWithValue }) => {
  try {
    return await requestChallengeImageUpload(file.challengeId, file.challengeImageType)
  } catch (error: any) {
    return rejectWithValue({ message: error.message, status: error.status })
  }
})

export const confirmChallengeMediaUpload = createAsyncThunk<
  ConfirmImageUploadResponse,
  { challengeId: string; challengeImageType: ChallengeImageType; waitForCompletion?: boolean }
>('challengesMedia/confirmUpload', async (file, { rejectWithValue }) => {
  try {
    return await confirmChallengeImageUpload(file.challengeId, file.challengeImageType, {
      waitForCompletion: file.waitForCompletion,
    })
  } catch (error: any) {
    return rejectWithValue({ message: error.message, status: error.status })
  }
})

export const getChallengeMedia = createAsyncThunk<
  GetImageResponse,
  { challengeId: string; challengeImageType: ChallengeImageType }
>('challengesMedia/getById', async (file, { rejectWithValue }) => {
  try {
    return await getChallengeImage(file.challengeId, file.challengeImageType)
  } catch (error: any) {
    return rejectWithValue({ message: error.message, status: error.status })
  }
})

export const deleteChallengeMedia = createAsyncThunk<
  DeleteImageResponse,
  { challengeId: string; challengeImageType: ChallengeImageType }
>('challengesMedia/delete', async (file, { rejectWithValue }) => {
  try {
    return await deleteChallengeImage(file.challengeId, file.challengeImageType)
  } catch (error: any) {
    return rejectWithValue({ message: error.message, status: error.status })
  }
})
